import { marketingEvent } from '$lib/constants/marketingModal';
import { usePersistentState } from '$lib/utils/persistentState.svelte';

export function useMarketingEvent() {
	const { maxNbOpening, storageKey } = marketingEvent;
	const marketingStorage = usePersistentState<number>(storageKey, 0, { storageType: 'local' });

	return {
		setUserHasParticipated: () => {
			marketingStorage.setCurrent(maxNbOpening);
		},
		setUserHasViewedModalOneTime: () => {
			marketingStorage.setCurrent(marketingStorage.getCurrent() + 1);
		},
		getCurrentOpeningNumber: () => {
			return marketingStorage.getCurrent();
		},
	};
}
